const LOCAL_PREVIEW_HOSTS = new Set([
  "localhost",
  "127.0.0.1",
  "::1",
  "[::1]",
]);

/**
 * Local preview builds are part of the development loop, so leaving a newly
 * built worker waiting makes the browser appear to ignore source changes.
 * Deployed installations keep the explicit update prompt to avoid reloading
 * while someone is writing.
 */
export function shouldAutoApplyPwaUpdate(
  location: Pick<Location, "hostname">,
): boolean {
  return LOCAL_PREVIEW_HOSTS.has(location.hostname.toLowerCase());
}

/**
 * The HTML shell has its own network-first current/previous cache. Allowing
 * Workbox's precache route to own the same URL would make that rollback route
 * unreachable and can pin an old build indefinitely.
 */
export function shouldPrecachePwaAsset(url: string): boolean {
  const pathname = new URL(url, "https://fengyue.local").pathname;
  return pathname !== "/index.html" && pathname !== "/sw.js";
}
